export function ExternalIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M11.5 9.75V11.25C11.5 11.3881 11.3881 11.5 11.25 11.5H4.75C4.61193 11.5 4.5 11.3881 4.5 11.25L4.5 4.75C4.5 4.61193 4.61193 4.5 4.75 4.5H6.25H7V3H6.25H4.75C3.7835 3 3 3.7835 3 4.75V11.25C3 12.2165 3.7835 13 4.75 13H11.25C12.2165 13 13 12.2165 13 11.25V9.75V9H11.5V9.75ZM8.5 3H9.25H12.2495C12.6637 3 12.9995 3.33579 12.9995 3.75V6.75V7.5H11.4995V6.75V5.56066L8.53033 8.52978L8 9.06011L6.93934 7.99945L7.46967 7.46912L10.4388 4.5H9.25H8.5V3Z"
      />
    </svg>
  )
}

export function SourceMappingErrorIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8.13748 3C8.69243 3.00017 9.20256 3.30665 9.46267 3.79688L13.5642 11.5312C13.9172 12.1971 13.434 12.9997 12.6804 13H3.32595C2.57197 13 2.08881 12.1973 2.44217 11.5312L6.54763 3.79688C6.80787 3.30678 7.31792 3.00005 7.87283 3H8.13748ZM4.15701 11.5H11.8494L8.13748 4.5H7.87283L4.15701 11.5ZM8.00857 9.55176C8.38926 9.55189 8.69788 9.86053 8.69802 10.2412C8.69802 10.622 8.38935 10.9305 8.00857 10.9307C7.62768 10.9307 7.31912 10.6221 7.31912 10.2412C7.31926 9.86045 7.62777 9.55176 8.00857 9.55176ZM8.75467 9H7.25467V6.25H8.75467V9Z"
        fill="currentColor"
      />
    </svg>
  )
}
